export namespace JsonApi {
  export const convertIds = data =>
    data.map(item => ({
      ...item,
      id: item._id,
      _id: undefined,
    }));
}
